(function ($, DGS) {
  DGS.OnLoad.getInstance().register(function () {
    var locationSelectorCountries = $('.location-selector #content .component.link-list.location-selector-list ul li a');
    locationSelectorCountries.each(function () {
      var locationSelectorCountry = $(this).attr("title");
      $(this).parent().prepend("<div class='country__name'>" + locationSelectorCountry + "</div>");
    });
  });
})(jQuery, window.DGS);